// extracted by mini-css-extract-plugin
module.exports = {"container":"UpdateContents_container_2xcdh","filelabel":"UpdateContents_filelabel_3udjH"};